import UserBlamable from "@/models/user/UserBlamable";
import {AttachmentSize} from "@/helpers/constants";
import CompanySimple from "@/models/company/CompanySimple";

export default class UserSimple extends UserBlamable {

	public company!: CompanySimple;
	public hasAvatar!: boolean;
	public avatarTimestamp!: number | null;

	public static avatarUrlSmall(userSimple: UserSimple | null): string | null {
		return this.avatarUrl(userSimple, AttachmentSize.s);
	}

	public static avatarUrlMedium(userSimple: UserSimple | null): string | null {
		return this.avatarUrl(userSimple, AttachmentSize.m);
	}

	public static avatarUrlLarge(userSimple: UserSimple | null): string | null {
		return this.avatarUrl(userSimple, AttachmentSize.l);
	}

	public static avatarUrlOriginal(userSimple: UserSimple | null): string | null {
		return this.avatarUrl(userSimple, AttachmentSize.orig);
	}

	private static avatarUrl(userSimple: UserSimple | null, size: AttachmentSize | null): string | null {
		if (null === userSimple) {
			return null;
		}
		if (!userSimple.hasAvatar) return null;
		return process.env.VUE_APP_API_BASE_URL + `user/${userSimple.id}/avatar?size=${size}&cache=${userSimple.avatarTimestamp}`;
	}

}
